import { render, staticRenderFns } from "./imei.vue?vue&type=template&id=bfd3c9fc&"
import script from "./imei.vue?vue&type=script&lang=js&"
export * from "./imei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\008-QLK_FE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfd3c9fc')) {
      api.createRecord('bfd3c9fc', component.options)
    } else {
      api.reload('bfd3c9fc', component.options)
    }
    module.hot.accept("./imei.vue?vue&type=template&id=bfd3c9fc&", function () {
      api.rerender('bfd3c9fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/imei.vue"
export default component.exports